import React, { useCallback, useState, useEffect } from "react";
import home_left from "../assets/images/home_left.png";
import home_right from "../assets/images/home_right.png";
import Carousel from "react-elastic-carousel";
import "../assets/styles/newstyle.css";
import "react-before-after-slider-component/dist/build.css";
import AOS from "aos";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
  ReactCompareSliderHandle,
} from "react-compare-slider";
import {
  Col,
  Container,
  Image,
  Row,
  Button,
  Card,
  Form,
} from "react-bootstrap";
import home_1stSec from "../assets/images/home_1stSec.png";
import home_fourth_section_right from "../assets/images/home_fourth_section_right.png";
import home_card1 from "../assets/images/home_card1.svg";
import home_card2 from "../assets/images/home_card2.svg";
import home_card3 from "../assets/images/home_card3.svg";
import JobsCard from "../Components/JobsCard";
import ForCompaniesCard from "../Components/ForCompaniesCard";
import BodyLoader from "../Components/BodyLoader";
import ReactPlayer from "react-player/lazy";
import Formb from "../Components/Formb";
import { Get } from "../Axios/AxiosFunctions";
import { useHistory } from "react-router";
import { imageUrl, URL } from "../Config/apiUrl";
import { useSelector } from "react-redux";
import Aos from "aos";

const Home = () => {
  const [isApiCall, setIsApiCall] = useState(true);
  const [pageData, setPageData] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [recommendedJobs, setRecommendedJobs] = useState([]);
  const [craftmen, setCraftmen] = useState([]);

  const history = useHistory();
  const [position, setPosition] = useState(50);
  const userData = useSelector((state) => state?.authReducer);
  const accessToken = useSelector((state) => state?.authReducer.access_token);
  console.log(userData);
  const handlePositionChange = useCallback(
    (nextPosition) => {
      if (position !== nextPosition) setPosition(nextPosition);
    },
    [position]
  );
  console.log("testTTTTTTTTTTTTTTTTTT", { pageData });
  // get data
  const getData = async () => {
    const url = URL("general/web/selected-page?name=home");
    const response = await Get(url);
    if (response !== undefined) {
      setPageData(response?.data?.data?.home);
      setAllServices(response?.data?.allServices);
      setCraftmen(response?.data?.craftman);
      setRecommendedJobs(response?.data?.recommendedJobs);
    }

    setIsApiCall(false);
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    Aos.init({ once: true })
  }, []);
  if (isApiCall) {
    return <BodyLoader />;
  }


  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1,  },
    { width: 850, itemsToShow: 3 },
    { width: 1150, itemsToShow: 3  },
    { width: 1450, itemsToShow: 3 },
    { width: 1515, itemsToShow: 3 },
    { width: 1750, itemsToShow: 3 },
  ]


  return (
    <>
      <div>
        <div className="banner_section">
          <ReactCompareSlider
            handle={
              <ReactCompareSliderHandle
                buttonStyle={{
                  backdropFilter: undefined,
                  background: "white",
                  border: 0,
                  color: "#333",
                }}
              />
            }
            className="handle_inner_index"
            onlyHandleDraggable={true}
            itemOne={
              <ReactCompareSliderImage
                style={{ width: `${position}%` }}
                className="left_image_text"
                src={`${imageUrl}${pageData?.cover_image_Craftman}`}
                srcSet={`${imageUrl}${pageData?.cover_image_Craftman}`}
                alt="Image one"
                text="this is text"
              />
            }
            itemTwo={
              <ReactCompareSliderImage
                style={{
                  // width: `${(100 - position) * 2}%`
                  left: `${position}%`,
                  position: "inherit",
                }}
                src={`${imageUrl}${pageData?.cover_image_Company}`}
                srcSet={`${imageUrl}${pageData?.cover_image_Company}`}
                alt="Image two"
              />
            }
            position={position}
            onPositionChange={handlePositionChange}
          />
          {position > 25 && (
            <div
              className="left_banner_styling"
              style={{
                position: "absolute",
                top: "50%",
                left: 0,
                // background: "red",
                color: "white",
                zIndex: 1000,
                width: `${position}%`,
                objectPosition: "100%",
              }}
            >
              <h2 className="text-center mb-4">
                {/* <span className="regular"> If you are </span> looking for <br />{" "}
                new challenges, */}
                <span>{pageData?.heading_Craftman}</span>
              </h2>
              <p className="mb-4 whito">
                {pageData?.detail_description_Craftman}
              </p>
              <Button
                className="trans_btn"
                onClick={() => {
                  history.push("/signup");
                }}
              >
                Create a profile
              </Button>
            </div>
          )}
          {position < 75 && (
            <div
              className="right_banner_styling"
              style={{
                position: "absolute",
                top: "50%",
                right: 0,
                // background: "blue",
                color: "white",
                zIndex: 1000,
                width: `${100 - position}%`,
              }}
            >
              <h2 className="text-center mb-4">
                {/* <span className="regular"> We have the </span> right <br />{" "}
                candidates */}
                <span>{pageData?.heading_Company}</span>
              </h2>
              <p className="mb-4 whito">
                {pageData?.detail_description_Company}
              </p>
              <Button
                className="trans_btn btn_sizing btn-width-36"
                onClick={() => {
                  history.push("/signup");
                }}
              >
                Create your company profile
              </Button>
            </div>
          )}
        </div>

        <Container>
          <Row className="first_row">
            <Col md={6} data-aos="fade-right">
              <Image src={`${imageUrl}${pageData?.sec1Image}`} fluid />
            </Col>
            <Col md={6} className="flex_without_a" data-aos="fade-left" >
              <h3 data-aos="fade-up" data-aos-duration="3000">
                {/* <span className="regular"> For you who want to </span> <br />
                find the dream job */}
                <span>{pageData?.sec1Heading}</span>
              </h3>
              <p
                className="first_sec_p "
                style={{
                  whiteSpace: "pre-line",
                }}
              >
                {pageData?.sec1Description}
              </p>
              <div className="first_sec_btn mt-4">
                <Button
                  onClick={() => {
                    history.push("/signup");
                  }}
                >
                  <span>Create a profile</span>
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <h3 className="text-center mb-5" data-aos="fade-up" data-aos-duration="3000">Recommended jobs</h3>
            <Carousel itemsToScroll={1} itemsToShow={3} showArrows={true}
            breakPoints={breakPoints}
            itemPadding={[5]}
            >
              {recommendedJobs?.map((E) => (
                <JobsCard data={E} col={12} />
              ))}
            </Carousel>
          </Row>
        </Container>
        <div className="home_4thSection_bg" data-aos="fade-up">
          <Container>
            <Row>
                <Col>
                  <ForCompaniesCard pageData={pageData} craftmen={craftmen} />
                </Col>
            </Row>
          </Container>
        </div>

        <Container className="small_container home_fifth_section_main">
          <Row>
            <Col md={12}>
              <div className="inner_section_top_content">
                <h3 className="text-center mb-4" data-aos="fade-up" data-aos-duration="3000">
                  {/* <span className="regular">About</span> DC STEEL */}
                  <span>{pageData?.sec3Heading}</span>
                </h3>
                <p className="text-center mb-4">{pageData?.sec3Description}</p>
                <p className="text-center mb-5">
                  Through our platform you have 3 different options:
                </p>
              </div>
            </Col>

            <Col className="main_col" md={12}>
              <Row>
                {/* cards */}
                <Col className="col_first" md={2}>
                  <Card className="home_card1 home_card_main">
                    <div className="img_div">
                      <Card.Img
                        variant="top"
                        src={`${imageUrl}${allServices[0]?.icon}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = home_card1;
                        }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="mb-4">
                        <h4> {allServices[0]?.title} </h4>
                      </Card.Title>
                      <Card.Text>{allServices[0]?.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={2} className="relative_div col_second">
                  <Card className="home_card2 home_card_main">
                    <div className="img_div">
                      <Card.Img
                        variant="top"
                        src={`${imageUrl}${allServices[1]?.icon}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = home_card2;
                        }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="mb-4">
                        <h4> {allServices[1]?.title}</h4>
                      </Card.Title>
                      <Card.Text>{allServices[1]?.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={2} className="relative_div col_third">
                  <Card className="home_card3 home_card_main">
                    <div className="img_div">
                      <Card.Img
                        variant="top"
                        src={`${imageUrl}${allServices[2]?.icon}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = home_card1;
                        }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="mb-4">
                        <h4> {allServices[2]?.title} </h4>
                      </Card.Title>
                      <Card.Text>{allServices[2]?.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} className="home_fifth_section col_forth">
                  <Image src={`${imageUrl}${pageData?.sec3Image}`} />
                </Col>
              </Row>
            </Col>

            
          </Row>
        </Container>

        <Container className="small_container">
          <Row>
            <Col>
              <ReactPlayer
                url={`${imageUrl}${pageData?.sec4Video}`}
                className="html5_video"
                controls
              />
            </Col>
          </Row>
        </Container>
        <Formb />
      </div>
    </>
  );
};

export default Home;
